import { AllyUserRole } from '@ally/transmitigator'

/**
 * Returns a single role based on priority order defined by UX/Content teams
 */
export const getDisplayRole = (allyUserRoles: AllyUserRole): string => {
  const { bank, creditcard, investment, mortgage } = allyUserRoles

  if (bank) return 'Bank'
  if (investment) return 'Invest'
  if (creditcard) return 'Credit Card'
  if (mortgage) return 'Home Loans'

  return ''
}
